import React, { useEffect, useRef, useState } from 'react';
import { skills } from '@/mock';
import '@/styles/SkillsSection.css';

const SkillsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const SkillBar = ({ skill, delay }) => (
    <div className="skill-item" style={{ animationDelay: `${delay}s` }}>
      <div className="skill-header">
        <span className="skill-name">{skill.name}</span>
        <span className="skill-percentage">{skill.level}%</span>
      </div>
      <div className="skill-bar-container">
        <div 
          className="skill-bar-fill" 
          style={{ 
            width: isVisible ? `${skill.level}%` : '0%',
            transitionDelay: `${delay}s`
          }}
        ></div>
      </div>
    </div>
  );

  return (
    <section className="skills-section" id="skills" ref={sectionRef}>
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Skills & Expertise</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Technical proficiencies and specializations</p>
        </div>

        <div className="skills-grid">
          <div className="skill-category">
            <h3 className="category-title">Programming Languages</h3>
            <div className="skills-list">
              {skills.languages.map((skill, idx) => (
                <SkillBar key={skill.name} skill={skill} delay={idx * 0.1} />
              ))}
            </div>
          </div>

          <div className="skill-category">
            <h3 className="category-title">Frameworks & Tools</h3>
            <div className="skills-list">
              {skills.frameworks.map((skill, idx) => (
                <SkillBar key={skill.name} skill={skill} delay={idx * 0.1} />
              ))}
            </div>
          </div>

          <div className="skill-category">
            <h3 className="category-title">Architecture & Design</h3>
            <div className="skills-list">
              {skills.architecture.map((skill, idx) => (
                <SkillBar key={skill.name} skill={skill} delay={idx * 0.1} />
              ))}
            </div>
          </div>

          <div className="skill-category">
            <h3 className="category-title">Development Tools</h3>
            <div className="skills-list">
              {skills.tools.map((skill, idx) => (
                <SkillBar key={skill.name} skill={skill} delay={idx * 0.1} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;